import { ServiceRequestBase } from "./ServiceRequestBase";

export class LastUpdatedRequest extends ServiceRequestBase {
}
